const SITES_DATA = [
{
    title: "This site! ;)",
    image: "/images/generic-project.jpg",
    description: "This is not just another pre-build template... it's a fully responsive React website built from scratch using React Hooks, Sass...",
    skills: ["React", "CSS-Flexbox", "Sass", "React Hooks", "..."],
    siteUrl: "N/A",
    githubUrl: "https://github.com/visconttig/portfolio-live",
    isLive: false
},
{
    title: "Crown Clothing",
    image: "/images/crwn-clothing.jpg",
    description: "An e-shop web application with databases, user authentication...",
    skills: ["React", "Firebase OAuth", "Firestore", "CSS-Flexbox", "Sass", "CSS", "Javascript", "..."],
    siteUrl: "https://glittering-dieffenbachia-cada1a.netlify.app/",
    githubUrl: "https://github.com/visconttig/crwn-clothing",
    isLive: true
},
{
    title: "Youtube Clone",
    image: "/images/portfolio-image.jpg",
    description: "A Youtube clone web app, with API calls, custom search...",
    skills: ["React", "APIs", "CSS-Flexbox", "Tailwind CSS", "Axios", "..."],
    siteUrl: "https://candid-banoffee-cf5b5e.netlify.app/",
    githubUrl: "https://github.com/visconttig/youtube_clone",
    isLive: true
},
{
    title: "Spotify Clone",
    image: "/images/spotify-clone.jpg",
    description: "A spotify-like web app, with custom search, geolocation...",
    skills: ["React", "APIs", "Redux", "Axios", "..."],
    siteUrl: "https://lively-pothos-f99b3f.netlify.app/",
    githubUrl: "https://github.com/visconttig/spotify-clone",
    isLive: false
},
{
    title: "Metaversus",
    image: "https://firebasestorage.googleapis.com/v0/b/cloud-storage-22017.appspot.com/o/Metaversus%2Fmetaversus-project.png?alt=media&token=a31db200-b7f6-4978-ba3b-87be45f541b2",
    description: "A beautiful Next.js app with animations and more.",
    skills: ["CSS", "HTML", "Javascript", "React Hooks"],
    siteUrl: "https://metaversus-delta-livid.vercel.app/",
    githubUrl: "https://github.com/visconttig/Metaversus",
    isLive: true
},
{
    title: "TinDog",
    image: "/images/tin-dog.jpg",
    description: "A simple site inspired on the famous Tinder website, to show some CSS, Javascript and Bootstrap expertise.",
    skills: ["CSS", "HTML", "Javascript", "Bootstrap"],
    siteUrl: "https://glittery-liger-f35185.netlify.app/",
    githubUrl: "https://github.com/visconttig/TinDog",
    isLive: true
},
{
    title: "Selenium Testing",
    image: "/images/generic-project.jpg",
    description: "Automated Testing Suite for a specific web application.",
    skills: ["Java ES8", "Selenium WebDriver, ..."],
    siteUrl: "N/A",
    githubUrl: "https://github.com/visconttig/Selenium-Testing2",
    isLive: false
}
];

export default SITES_DATA;